import { render } from "./PageAbout.vue?vue&type=template&id=740f5812&scoped=true"
import script from "./PageAbout.vue?vue&type=script&lang=js"
export * from "./PageAbout.vue?vue&type=script&lang=js"

import "./PageAbout.vue?vue&type=style&index=0&id=740f5812&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740f5812"]])

export default __exports__